import { Col } from 'antd';
import { Rule } from 'antd/lib/form';

import { FormItem } from '../Form';
import { InputCPF } from '../InputCPF';

type FormItemCPFProps = {
  colSpan?: number;
  required?: boolean;
  readOnly?: boolean;
  onChange?: (event: any) => void;
  name?: string | string[];
  label?: string;
};

export function FormItemCPF(props: FormItemCPFProps) {
  const { colSpan, required, readOnly, onChange, name, label } = props;

  const getRules = () => {
    const rules: Rule[] = [];
    rules.push({ required, message: 'Campo obrigatório' });
    return rules;
  };

  return (
    <Col span={colSpan || 24}>
      <FormItem label={label || 'CPF'} name={name || 'cpf'} rules={getRules()}>
        <InputCPF onChange={onChange} readOnly={readOnly} />
      </FormItem>
    </Col>
  );
}
